


































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import fetch from 'node-fetch'
import { CognitoIdentityServiceProvider } from 'aws-sdk'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

@Component
export default class MFA extends Vue {
  public mfaCode = ''
  private protocolApi: string = Vue.prototype.$secureApi ? 'https' : 'http'
  public accessToken = ''
  private codeType = 0
  public mfaErrors: string[] = []

  // props
  @Prop(String) readonly session!: string;
  @Prop(String) readonly email!: string;
  @Prop(String) readonly phoneNumber!: string;

  async mounted () {
    const accessToken = Vue.$cookies.get('accessToken')
    if (!isNaN(+this.phoneNumber) && accessToken) {
      this.accessToken = accessToken
      this.codeType = 1
      return
    } else if (this.session && this.email && this.phoneNumber) {
      return
    }
    await this.$router.push('/')
  }

  private async submitLoginMFAChallenge (): Promise<void> {
    const response = await fetch(`${this.protocolApi}://${Vue.prototype.$hostApi}/api/respond-challenge`, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({
        email  : this.email,
        session: this.session,
        mfaCode: this.mfaCode
      })
    })
    if (!response.ok) {
      console.log(response) // User something went wrong
      this.mfaErrors.push('Something went wrong.')
      return
    }
    const responseBody = await response.json()
    if ('message' in responseBody) {
      console.error(responseBody) // User responseBody.message
      this.mfaErrors.push(responseBody.message)
      return
    }

    Vue.$cookies.config('7d', '/', Vue.prototype.$domain, Vue.prototype.$secureCookies)
    Vue.$cookies.set('accessToken', responseBody.AccessToken)
    Vue.$cookies.set('idToken', responseBody.IdToken)
    Vue.$cookies.set('refreshToken', responseBody.RefreshToken)

    const accessTokenB64 = responseBody.AccessToken.split('.')[1]
    const idTokenB64 = responseBody.IdToken.split('.')[1]
    const accessTokenDecoded = JSON.parse(window.atob(accessTokenB64))
    const idTokenDecoded = JSON.parse(window.atob(idTokenB64))
    const customers: string[] = accessTokenDecoded['cognito:groups'].filter((el: string) => el !== 'Admin')
    const isAdmin: boolean = accessTokenDecoded['cognito:groups'].filter((el: string) => el === 'Admin').length > 0
    let customerRedirect: number | null = null

    if (+idTokenDecoded['custom:current_customer'] && (isAdmin || customers.includes(
      idTokenDecoded['custom:current_customer']))) {
      customerRedirect = +idTokenDecoded['custom:current_customer']
    } else {
      customerRedirect = +customers[0]
    }
    let url = this.$route.query.url
    if (url && typeof url === 'string') {
      const goodDomain = await fetch(
        `${this.protocolApi}://${Vue.prototype.$centralApi}/domain/valid-redirect?domain=${url}`, {
          method : 'GET',
          headers: {
            'X-Id'       : responseBody.idToken,
            Authorization: `Token ${responseBody.accessToken}`
          }
        })
      if (goodDomain.ok) {
        try {
          if (!url.includes('://')) {
            url = `${this.protocolApi}://${url}`
          }
          window.location.href = url
          return
        } catch (err) {
          console.error(err)
          return
        }
      }
    }
    const customerResp = await fetch(
      `${this.protocolApi}://${Vue.prototype.$centralApi}/customer/${customerRedirect}`, {
        method : 'GET',
        headers: {
          'X-Id'       : responseBody.IdToken,
          Authorization: `Token ${responseBody.AccessToken}`
        }
      })
    try {
      const { subdomain: customerSubdomain } = await customerResp.json()
      window.location.href = `${this.protocolApi}://${customerSubdomain}${Vue.prototype.$domain}${Vue.prototype.$customerPort ? ':' + Vue.prototype.$customerPort : ''}/#/dashboard`
    } catch (err) {
      console.error(err)
    }
  }

  private async submitVerifyCode () {
    const provider = new CognitoIdentityServiceProvider({ region: 'us-west-2' })
    try {
      await new Promise((resolve, reject) => {
        provider.verifyUserAttribute({
          AccessToken  : this.accessToken,
          AttributeName: 'phone_number',
          Code         : this.mfaCode
        }, (err, data) => {
          if (err) {
            reject(err)
          } else {
            resolve(data)
          }
        })
      })
      await fetch(`${this.protocolApi}://${Vue.prototype.$hostApi}/api/set-mfa`, {
        method: 'POST',
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        credentials: 'include',
        headers    : {
          'Content-Type': 'application/json'
        }
      })
      window.close()
    } catch (e) {
      console.error(e)
      if ('message' in e) {
        this.mfaErrors.push(e.message)
      } else {
        this.mfaErrors.push('Something went wrong')
      }
    }
  }

  // methods
  public async submitMfaChallenge (): Promise<void> {
    if (this.mfaCode) {
      if (this.codeType === 1) {
        await this.submitVerifyCode()
      } else {
        await this.submitLoginMFAChallenge()
      }
    }
  }
}

